export const passRule = {
  data: () => ({
    passRuleDialog: {
      activate: false,
      status: 'new',
      item: {},
      index: 0,
    },
  }),
  methods: {
    openSetRuleDialog (status, item, index) {
      this.passRuleDialog = {
        activate: true,
        status: status,
        item: item || undefined,
        index: index,
      }
    },
    closeSetRuleDialog () {
      this.passRuleDialog = {
        activate: false,
        status: 'new',
        item: undefined,
        index: 0,
      }
    },
    async setPassRuleLocal ({newItem, oldItem, status}, array) {
      if (!newItem) {
        this.passRuleDialog.activate = false
        return
      }
      if (status === 'new' && newItem) {
        array.push(newItem)
      }
      if (status === 'edit' && newItem) {
        let i = array.indexOf(oldItem)
        if (i !== -1) {
          array.splice(i, 1, newItem)
        }
      }
      this.closeSetRuleDialog()
    },
    async deleteRuleLocal (r, array) {
      if (r) {
        let {res, close} = await this.$L.confirm({
          title: '确认删除',
          text: '确认删除此规则？',
        })
        if (res) {
          let i = array.indexOf(r)
          // console.log(r, i)
          if (i !== -1) {
            array.splice(i, 1)
          }
        }
        close()
      }
    },
  }
}
